import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { appLaunchTrack } from 'app-webtech-core/modules/application/actions';
import { selectors } from 'app-webtech-core/selectors';
import { cmError } from 'app-webtech-core/modules/podTracker/ads/actions/cmEvent';
import { SET_ERROR } from './types';

const playerSetErrorAction = actionCreator(SET_ERROR);

export const playerSetErrorThunkAction = (error) => (dispatch, getState) => {
  const state = getState();
  dispatch(playerSetErrorAction(error));

  const { currentPlayingAd } = selectors.playbackSession.properties(state);
  if (currentPlayingAd) {
    const { adBreakDuration, ad } = currentPlayingAd;
    dispatch(cmError({ adBreakDuration, ad }));
  }
  dispatch(appLaunchTrack(true));
};
